'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Ad = require('./Ad');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ad).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/Ad/index.js
 ** module id = 457
 ** module chunks = 1
 **/